import { Container } from '../../../odie';

import { CandyBagBlockProps } from '../../defs/block';
import { blockPositionView } from '../../util/blockTools';
import { FitWidthBlockSprite } from './FitWidthBlockSprite';

// constants
//-----------------------------------------------------------------------------
const manifest = {
  image: 'candy/block.candy.bag.png',
};

/*
    candy bag block view
*/
export class CandyBagBlockView extends Container {
  // init
  //-------------------------------------------------------------------------
  constructor(props: CandyBagBlockProps) {
    // create base view
    super();
    this.addChild(new FitWidthBlockSprite(manifest.image, props));
    blockPositionView(this, props);
    this.y += 1;
  }

  public static assets(): string[] {
    return Object.values(manifest);
  }
}
